import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConstant } from '../models/app-constant';
import { APP_CONSTANTS } from './app.contant';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    DELETE<T>(MODULE_NAME: string, DELETE_BRANDING_CREATIVES: any, body: any): import('rxjs').Observable<any> {
        throw new Error('Method not implemented.');
    }
    private baseUrl: string;
    constructor(
        private http: HttpClient,
        @Inject(APP_CONSTANTS) private appConstants: AppConstant,
    ) {
        this.baseUrl = `${appConstants.PROTOCOL}://${appConstants.IP}`;
    }

    get<U>(moduleName: string, action: string, options = {}) {
        const method = 'GET';
        const path = this.resolvePath(moduleName, action);
        const url = `${this.baseUrl}${path}`;
        return this.http.request<any | ArrayBuffer>(method, url, options);
    }

    post<U>(moduleName: string, action: string, body: any, options = {}) {
        const method = 'POST';
        const path = this.resolvePath(moduleName, action);
        const url = `${this.baseUrl}${path}`;
        return this.http.request<any>(method, url, {
            body,
            ...options,
        });
    }
    put<U>(moduleName: string, action: string, body: any, options = {}) {
        const method = 'PUT';
        const path = this.resolvePath(moduleName, action);
        const url = `${this.baseUrl}${path}`;
        return this.http.request<any>(method, url, {
            body,
            ...options,
        });
    }
    delete<U>(moduleName: string, action: string, options = {}) {
        const method = 'DELETE';
        const path = this.resolvePath(moduleName, action);
        const url = `${this.baseUrl}${path}`;
        return this.http.request<any | ArrayBuffer>(method, url, options);
    }
    patch<U>(moduleName: string, action: string, body: any, options = {}) {
        const method = 'PATCH';
        const path = this.resolvePath(moduleName, action);
        const url = `${this.baseUrl}${path}`;
        return this.http.request<any>(method, url, {
            body,
            ...options,
        });
    }
    private resolvePath(moduleName: string, action: string) {
        return `${this.appConstants.API_PATHS[moduleName]}/${action}`;
    }

}
